module.exports = __webpack_public_path__ + "img/img-3.81c24fc3.webp";